import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>© {new Date().getFullYear()} All images drawn by Tina. Some of them are based on popular characters.</p>
  </footer>
);

export default Footer; 